import { filterAgenciesByOrigin } from 'modules/filter-agencies-by-origin/filter-agencies-by-origin';
import { useAgencies as useReduxAgencies } from 'hooks/redux/useAgencies';
import { isPending } from 'redux/statuses';
import { useOrigin } from 'hooks/useOrigin';
import { AGENCIES } from 'constants/constants';

export function useAgencies(filterByOrigin = true) {
  const { agencies, agenciesStatus } = useReduxAgencies();
  const origin = useOrigin();

  const agenciesWithGroup = agencies.map((agency) => {
    const group = AGENCIES[agency.agency_code]?.group;
    return { ...agency, group };
  });

  return {
    agencies: filterByOrigin
      ? filterAgenciesByOrigin(agenciesWithGroup, origin)
      : agenciesWithGroup,
    loadingAgencies: isPending(agenciesStatus),
  };
}
